import { io, Socket } from "socket.io-client";
import { getUrl } from "./utils/helper-function";

export const socket: Socket = io(getUrl(), {
    autoConnect: false 
});

/**
 * Initializes WebSocket for a hotel.
 * Connects to backend, joins hotel room, and auto-rejoins on reconnect.
 * 
 * @param hotelId - Unique identifier for the hotel
 */
export const setupSocket = (hotelId: string) => {
    socket.connect();                // open socket connection
    socket.emit("join_hotel", hotelId); // join hotel room

    // Rejoin room on reconnect
    socket.on("connect", () => socket.emit("join_hotel", hotelId));

    // Log disconnects
    socket.on("disconnect", () => console.log("Socket disconnected"));
};